import type { Tracker } from '@archipro-website/tracker';
import type { CreateEnquirySource } from '~/modules/enquiry';
import type { EnquiryItemType } from './trackEnquireReveal';

interface TrackProps {
    professionalName: string;
    itemID: number;
    itemType: EnquiryItemType;
    source: CreateEnquirySource;
    professionalID: number;
}

/**
 * Track the `EnquiryFormEngagement` event. Fires once per rendered enquiry
 * form when the user first edits any field — the "started typing" stage of
 * the enquiry funnel between `EnquiryReveal` and
 * `SubmitCreateEnquiryRequest`.
 */
export const trackEnquiryFormEngagement = (
    tracker: Tracker,
    props: TrackProps,
) => {
    tracker.log('EnquiryFormEngagement', {
        url: new URL(window.location.href),
        label: props.professionalName,
        data: {
            Source: props.source,
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
            professionalID: props.professionalID,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
};

/**
 * Track the `EnquiryAuthPrompt` event. Fires when a logged-out user submits
 * the enquiry form and is shown the login / signup wall — the last funnel
 * stage before `CreatedEnquiry` for guests. `CTA_Label` records which flow
 * was offered (`login` for an existing account, `signup` for a new one).
 */
export const trackEnquiryAuthPrompt = (
    tracker: Tracker,
    props: TrackProps & { flow: 'login' | 'signup' },
) => {
    tracker.log('EnquiryAuthPrompt', {
        url: new URL(window.location.href),
        label: props.professionalName,
        data: {
            Source: props.source,
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
            CTA_Label: props.flow,
            professionalID: props.professionalID,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
};
